import React,{ useState, useEffect } from 'react';
import { useNavigate  } from 'react-router-dom';
import { Col, Row } from 'antd';
import { PlusCircleOutlined } from '@ant-design/icons';


import logo from '../../image/logo.svg'



import BaseButton from '../BaseButton/BaseButton';
import CardDom from '../CardDom/CardDom';

import './BigCard.less'

// {
//   type: 'bgCard'
//   bgImg: require('../../image/bigCardBg-3840x1440.png'),
//   contentWidth: '30%',
//   textPosition: 'right',
//   title: '线粒体能量工厂',
//   description: 'Mitopure® was developed after over a decade of scientific research. Dig deeper into the science behind a game-changing discovery for cellular health.',
//   btnConfig:{
//     text: 'Learn more',
//     link: ''
//   }
// }
const BigCard = ({bigCardData}) =>{
  const [width, setWidth] = useState(window.innerWidth);
  useEffect(()=>{
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
 
    // 添加事件监听器
    window.addEventListener('resize', handleResize);
 
    // 清理函数，组件卸载时移除事件监听器
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  },[])

  if(bigCardData.type === 'bgCard'){
    let renderBtn
    if(bigCardData.btnConfig){
      if(bigCardData.btnConfig.icon === 'PlusCircleOutlined'){
        renderBtn = (
          <div style={{display:'flex', alignItems: 'center', marginTop: 20}}>
            <PlusCircleOutlined style={{fontSize: 28, marginRight: 20}}/>
            <div style={{lineHeight:1}}>
              {bigCardData.btnConfig.text}
            </div>
          </div>
        )
      }else{
        renderBtn = <BaseButton style={width>770? {cursor: 'pointer'}:{width:'100%', cursor: 'pointer'}} btnConfig={bigCardData.btnConfig}/>
      }
    }
    if(width > 770){
      return (
        <div className="BigCard-box">
          <img src={bigCardData.bgImg} alt="" />
          <div 
              className="BigCard-content-box" 
              style={
                bigCardData.textPosition === 'right'? 
                  {width: bigCardData.textWidth, right: 50}
                  :
                  {width: bigCardData.textWidth, left: 50}
              }
            >
            <div className="title">{bigCardData.title}</div>
            <div className="description" style={{marginTop: 20}}>{bigCardData.description}</div>
  
            {renderBtn}
          </div>
        </div>
      )
    }else{
      return (
        <div className="BigCard-box-phone">
          <img src={bigCardData.bgImg} alt="" />
          <div 
              className="BigCard-content-box" 
              style={
                bigCardData.textPosition === 'right'? 
                  { right: 50, marginTop: 20 }
                  :
                  { left: 50, marginTop: 20 }
              }
            >
            <div className="title">{bigCardData.title}</div>
            <div className="description" style={{marginTop: 20}}>{bigCardData.description}</div>
  
            {renderBtn}
          </div>
        </div>
      )
    }
  }else if(bigCardData.type === 'imgCard'){
    // 判断文字在左边还是右边
    const positionObj = {display: 'flex',justifyContent: 'space-between'}
    if(bigCardData.textPosition === 'left'){
      positionObj.flexDirection = 'row-reverse'
    }
    // 判断文字在中间还是在顶部
    const textAlignItemObj = {width: bigCardData.textWidth, display: 'flex', flexDirection: 'column'}
    if(bigCardData.textAlignItem === 'center'){
      textAlignItemObj.justifyContent = 'center'
    }
    
    
    if(width > 770){
      return (
        <div style={{width: '100%',maxWidth: 1440, margin:'50px auto', ...positionObj}}>
          <img style={{width: '45%'}} src={bigCardData.bgImg} alt="" />
          <div style={textAlignItemObj}>
            <div style={{fontSize: bigCardData.titleSize, lineHeight: 1, marginBottom: bigCardData.spacing}}>{bigCardData.title}</div>
            <p style={{fontSize: bigCardData.descriptionSize, color: bigCardData.descriptionColor}}>{bigCardData.description}</p>
            
            {bigCardData.childDom? 
              <Row gutter={[40, 40]} style={{marginTop: 40}}>
                {bigCardData.childDom.map((e)=>{
                  return (
                    <Col span={12} key={e.content.title}>
                      <CardDom type={e.type} content={e.content} btnConfig={e.btnConfig}/>
                    </Col>
                  )
                })}
              </Row>
              :
              ''
            }
            
          </div>
        </div>
      )
    }else{
      return (
        <div style={{width: '100%', padding: '0 25px',marginBottom:50}}>
          <img style={{width: '100%',marginBottom:20}} src={bigCardData.bgImg} alt="" />
          <div>
            <div style={{fontSize: bigCardData.titleSize, lineHeight: 1, marginBottom: bigCardData.spacing}}>{bigCardData.title}</div>
            <p style={{fontSize: bigCardData.descriptionSize, color: bigCardData.descriptionColor}}>{bigCardData.description}</p>
            
            {bigCardData.childDom? 
              <Row gutter={[40, 40]} style={{marginTop: 40}}>
                {bigCardData.childDom.map((e)=>{
                  return (
                    <Col span={12} key={e.content.title}>
                      <CardDom type={e.type} content={e.content} btnConfig={e.btnConfig}/>
                    </Col>
                  )
                })}
              </Row>
              :
              ''
            }
            
          </div>
        </div>
      )
    }
  }else if(bigCardData.type === 'goodCard'){
    return (
      <div style={{width: '100%', maxWidth: 1440, margin: '0 auto'}}>
        <Row justify={width>770? "space-between":"center"} align="middle" style={{marginTop:40}}>
          <Col span={width>770? 8:24} style={width>770? {padding: 20,textAlign:'left'}:{padding: 25,textAlign:'left'}}>
            {/* <img src={logo} alt="" style={{width: 85}}/> */}
            <div style={{fontSize: "clamp(32px, calc(27.07px + 1.31vw), 46px)", marginTop: 10, lineHeight:1.15}}>{bigCardData.title}</div>
            <div style={{fontSize: "clamp(16px, calc(15.65px + 0.09vw), 17px)", marginTop: 30}}>{bigCardData.description}</div>
          </Col>
          {bigCardData.cardList.map((e,i)=>{
            return (
              <Col key={i} span={width>770? 8:24} style={width>770? {padding: 10, cursor: 'pointer'}:{padding: 25, cursor: 'pointer'}}>
                <CardDom type={e.type} img={e.img} content={e.content} btnConfig={e.btnConfig}/>
              </Col>
            )
          })}
        </Row>
      </div>
    )
  }else if(bigCardData.type === 'dbCard'){
    if(width > 770){
      // TODO: 宽度小于1440时会出现滚动条，需要调整
      return (
        <div style={{width: '100%', maxWidth: 1440, margin: '0 auto'}}>
          <div style={{display:'flex', justifyContent: 'space-between'}}>
            <div style={{width: '45%',fontSize: "clamp(32px, calc(27.07px + 1.31vw), 46px)", marginTop: 10, lineHeight:1.15}}>{bigCardData.title}</div>
            <div style={{width: '45%',fontSize: "clamp(16px, calc(15.65px + 0.09vw), 17px)", marginTop: 30}}>{bigCardData.description}</div>
          </div>
          <Row justify="space-between" align="middle" style={{marginTop:40}}>
            {bigCardData.list.map((e)=>{
              return (<Col span={12} key={e.title} style={{padding: '0 20px'}}>
                <img src={e.img} alt="" style={{width: '100%'}}/>
                <div style={{fontSize:'clamp(16px, calc(15.65px + 0.09vw), 17px)', padding: '24px 0'}}>{e.title}</div>
                {e.childList.map((E, I)=>{
                  return <div key={I} style={{display:'flex', justifyContent: 'space-between', padding: '24px 0 40px',borderTop: '1px solid rgba(0,0,0,0.12)',borderBottom: '1px solid rgba(0,0,0,0.12)'}}>
                    <div style={{width: '45%',fontSize:'clamp(22px, calc(19.89px + 0.56vw), 28px)'}}>{E.title}</div>
                    <div style={{width: '45%',fontSize:'clamp(16px, calc(15.65px + 0.09vw), 17px)', color:'rgba(0,0,0,0.54)'}}>
                      {E.description}
                      <div style={{marginTop: 20, borderBottom: '2px solid rgba(0,0,0,0.12)', display: 'inline-block'}}>See clinical study</div>
                    </div>
                  </div>
                })}
              </Col>)
            })}
          </Row>
        </div>
      )
    }else{
      return (
        <div style={{width: '100%', maxWidth: 1440, margin: '0 auto'}}>
          <div style={{width: '100%',fontSize: "clamp(32px, calc(27.07px + 1.31vw), 46px)", padding: '0 25px', marginTop: 10, lineHeight:1.15}}>{bigCardData.title}</div>
          <div style={{width: '100%',fontSize: "clamp(16px, calc(15.65px + 0.09vw), 17px)", padding: '0 25px', marginTop: 30}}>{bigCardData.description}</div>
          
          <div style={{width: '100%', overflowX: 'auto'}}>
            <div style={{width: '150%', padding: '0 25px'}}>
              <Row justify="space-between" align="middle" style={{marginTop:40}} gutter={[16, 16]}>
                {bigCardData.list.map((e)=>{
                  return (<Col span={12} key={e.title}>
                    <img src={e.img} alt="" style={{width: '100%'}}/>
                    <div style={{fontSize:'clamp(16px, calc(15.65px + 0.09vw), 17px)', padding: '24px 0'}}>{e.title}</div>
                    {e.childList.map((E, I)=>{
                      return <div key={I} style={{ padding: '24px 0 40px',borderTop: '1px solid rgba(0,0,0,0.12)',borderBottom: '1px solid rgba(0,0,0,0.12)'}}>
                        <div style={{width: '100%',fontSize:'clamp(22px, calc(19.89px + 0.56vw), 28px)'}}>{E.title}</div>
                        <div style={{width: '100%',fontSize:'clamp(16px, calc(15.65px + 0.09vw), 17px)', color:'rgba(0,0,0,0.54)'}}>
                          {E.description}
                          <div style={{marginTop: 20, borderBottom: '2px solid rgba(0,0,0,0.12)', display: 'inline-block'}}>See clinical study</div>
                        </div>
                      </div>
                    })}
                  </Col>)
                })}
              </Row>
            </div>
          </div>
        </div>
      )
    }
  }
}

export default BigCard